export default __webpack_public_path__ + "static/media/wiki.a0d89fef.png";